import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route } from 'react-router-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import AdminApp from 'layouts/AdminApp.jsx';
import { ThemeProvider } from '@material-ui/core';
import rootReducer from './rootReducer';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/css/demo.css';
import 'react-datepicker/dist/react-datepicker.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './global-style.css';

import constants from './config/constants';
import { validateUserLoggedIn, logout, showToast } from './actions/admin/auth';
import { fetchAllSchoolsService, fetchSchoolService } from './actions/admin/schools';
import { getLoggedUserUtils } from './utils/commonFunc';

// New
import theme from './theme';
import GlobalStyles from './theme/GlobalStyles';
// Axios
import axios from 'axios';

export const isMobileView = window.innerWidth < 769;
export const isLapView = window.innerWidth > 1024;
export let store = null;
window.$ = require('jquery');

let timer;
let sessionExpiredHandled = false;
if (window.location.pathname !== '/') {
  import('assets/css/paper-dashboard.css');
} else {
  // require("assets/landing/bootstrap/bootstrap.min.css")
  import('assets/landing/themify-icons/themify-icons.css');
  import('assets/landing/slick/slick.css');
  import('assets/landing/slick/slick-theme.css');
  import('assets/landing/fancybox/jquery.fancybox.min.css');
  import('assets/landing/aos/aos.css');
}

window.addEventListener('load', handleLoad);
function handleLoad() {
  const spinner = document.getElementById('loading');
  if (spinner && !spinner.hasAttribute('hidden')) {
    spinner.setAttribute('hidden', 'true');
  }
  document.getElementById('root'); // add to load page after css load
}

store = createStore(rootReducer, applyMiddleware(thunk));

const handleLogout = () => {
  clearTimeout(timer);
  store.dispatch(logout());
};

const userData = getLoggedUserUtils();
if (userData) {
  store.dispatch(validateUserLoggedIn(userData));
  if (userData?.userRole === constants.roles.SA) {
    store.dispatch(fetchAllSchoolsService({ token: userData.accessToken }));
  } else if (userData?.userRole !== constants.roles.teacher) {
    if (userData?.schoolId) {
      store.dispatch(fetchSchoolService({ schoolId: userData.schoolId, token: userData.accessToken }));
    }
  }
} else {
  handleLogout();
}

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    console.error('===== API ERROR =====', error);
    if (error?.response?.status === 401 && error.response?.data?.error === 'Session expired') {
      // Every call that is in flight fails together: warn and log out once, and leave the callers waiting (a rejected call
      // would reach code that has no catch, or show its own error) until the logout clears the page.
      if (!sessionExpiredHandled) {
        sessionExpiredHandled = true;
        store.dispatch(showToast('Session Expired. We are logging you out, Please login again', 'error'));
        timer = setTimeout(() => {
          handleLogout();
          setTimeout(() => {
            sessionExpiredHandled = false;
          }, 3000);
        }, 5000);
      }
      return new Promise(() => {});
    } else {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      return Promise.reject(error);
    }
  }
);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <BrowserRouter>
        <Route component={AdminApp} />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
